// extracted by mini-css-extract-plugin
export default {"tableHeading":"wastePercentageTable__tableHeading___indQu"};